import PropTypes from 'prop-types';

export default function ButtonLoader({ label, className = "" }) {
  return (
    <span className={`flex items-center justify-center gap-2 ${className}`}>
      <svg
        className="h-4 w-4 animate-spin text-current"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          d="M4 12a8 8 0 0 1 8-8"
          stroke="currentColor"
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      <span>{label}</span>
    </span>
  );
}

ButtonLoader.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

ButtonLoader.defaultProps = {
  className: "",
};
